import Hammer from 'hammerjs';

import core from './core';
import Tracker from '../helpers/tracker';
import { TrackingData } from '../helpers/TrackingTypes';
import { GA4BannerTracker } from './GA4/GA4BannerTracker';

const gallery = core.extend({
	constructor(options) {
		this.config = {
			selectors: {
				controlsHolder: '.controls-holder',
				switcher: '.controls li',
				slider: '.slider',
				slide: '.slider li',
				next: '.next-btn',
				prev: '.prev-btn',
			},
			holder: '.slider-holder',
			active: 'active',
			duration: 500,
			autoSliding: {
				active: true,
				intervalTime: 5000,
			},
		};

		_.extend(this.config, options || {});

		this.$ = {};

		this.$.holder = jQuery(this.config.holder);

		this.loadObjects(this.$.holder);

		this.hammer = new Hammer(this.$.slider[0]);

		this.init();

		this.attachEvents();

		if (this.config.autoSliding.active) {
			this.toggleAutoSliding();
		}
	},

	init() {
		this.$.slide.hide().css({ opacity: 0 }).eq(0).show().css({ opacity: 1 });
	},

	goToSlide(current, next) {
		this.animating = true;

		this.$.slide.eq(current).animate({ opacity: 0 }, this.config.duration, function () {
			jQuery(this).hide();
		});

		this.$.slide
			.eq(next)
			.show()
			.animate({ opacity: 1 }, this.config.duration, () => {
				this.animating = false;
			});
	},

	changeActiveSlide(num) {
		this.$.slide.removeClass(this.config.active).eq(num).addClass(this.config.active);

		this.$.switcher.removeClass(this.config.active).eq(num).addClass(this.config.active);
	},

	changeTheme(elNum) {
		const className = this.$.slide.eq(elNum).attr('class');

		this.$.controlsHolder.removeClass().addClass(`${className} ${this.config.selectors.controlsHolder.substr(1)}`);
	},

	switchSlide(current, next) {
		this.goToSlide(current, next);

		this.changeActiveSlide(next);

		this.changeTheme(next);
	},

	attachEvents() {
		this.$.switcher.on('click', (event) => this.onSwitchClick(event));

		this.$.prev.on('click', (event) => this.onPrevClick(event));

		this.$.next.on('click', (event) => this.onNextClick(event));

		this.$.holder.on('mouseenter mouseleave', () => this.toggleAutoSliding());

		this.hammer.on('swipeleft swiperight', (event) => this.handleSwipeEvents(event));
	},

	handleSwipeEvents(event) {
		if (event.type === 'swiperight') {
			this.onPrevClick();
		} else if (event.type === 'swipeleft') {
			this.onNextClick();
		}
	},

	onSwitchClick(event) {
		if (this.animating) {
			return;
		}

		const curSlideNum = this.getActiveSlideNumber();
		const prevSlideNum = event.currentTarget.getAttribute('data-index');

		this.switchSlide(curSlideNum, prevSlideNum);

		Tracker.track({
			category: this.config.trackingCategory,
			action: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
			label: `slide_${prevSlideNum}`,
		});
		GA4BannerTracker.trackBannerClick({
			block_section: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
			block_index: `slide_${prevSlideNum}`,
			content_name: this.config.trackingCategory,
			content_id: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
		});
	},

	toggleAutoSliding() {
		if (this.interval) {
			clearInterval(this.interval);

			this.interval = false;
		} else {
			this.interval = setInterval(() => this.onNextClick(), this.config.autoSliding.intervalTime);
		}
	},

	onPrevClick(event) {
		if (this.animating) {
			return false;
		}

		const curSlideNum = this.getActiveSlideNumber();
		const prevSlideNum = curSlideNum - 1 < 0 ? this.$.slide.length - 1 : curSlideNum - 1;

		this.switchSlide(curSlideNum, prevSlideNum);

		if (event) {
			Tracker.track({
				category: this.config.trackingCategory,
				action: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
				label: TrackingData.LABEL_LEFT,
			});
			GA4BannerTracker.trackBannerClick({
				block_section: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
				block_index: TrackingData.LABEL_LEFT,
				content_name: this.config.trackingCategory,
				content_id: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
			});
		}
	},

	onNextClick(event) {
		if (this.animating) {
			return false;
		}
		const curSlideNum = this.getActiveSlideNumber();
		const nextSlideNum = curSlideNum + 1 >= this.$.slide.length ? 0 : curSlideNum + 1;

		this.switchSlide(curSlideNum, nextSlideNum);

		if (event) {
			Tracker.track({
				category: this.config.trackingCategory,
				action: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
				label: TrackingData.LABEL_RIGHT,
			});
			GA4BannerTracker.trackBannerClick({
				block_section: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
				block_index: TrackingData.LABEL_RIGHT,
				content_name: this.config.trackingCategory,
				content_id: TrackingData.ACTION_SLIDER_1_BANNER_SLIDE,
			});
		}
	},

	getActiveSlideNumber() {
		return parseInt(this.$.slide.filter(`.${this.config.active}`).data('index'), 10);
	},
});

export default gallery;
